export default __webpack_public_path__ + "static/media/2021.34b4b593.png";